import { compose, lifecycle, withHandlers, withState } from 'recompose'
import Theme from 'components/common/Theme/Theme'
import debounce from 'lodash/debounce'
import { noop } from 'helpers/utils'
import InfinityScroll from './InfinityScroll'
import { scrollHelper } from './helpers'

const withInfinityScrollRef = withState('infinityRef', 'setInfinityRef', null)

const withScrollHandlers = withHandlers({
  handleScroll: ({ handler = noop, scrollPadding = 0, infinityRef }) =>
    debounce(() => {
      // second calls in the event page is stuck at the bottom
      scrollHelper({ handler, scrollPadding, infinityRef })
    }, Theme.scrollDebounceTimeout)
})

const withEventListenerManagement = lifecycle({
  componentDidMount() {
    const { handleScroll } = this.props
    window.addEventListener('scroll', handleScroll)
  },
  componentDidUpdate({ infinityRef: pastInfinityRef }) {
    const { handleScroll, infinityRef } = this.props
    const { prevTop = 0, prevBottom = 0 } = pastInfinityRef ? pastInfinityRef.getBoundingClientRect() : {}
    const { top = 0, bottom = 0 } = infinityRef ? infinityRef.getBoundingClientRect() : {}
    if (!!pastInfinityRef && !!infinityRef && prevTop !== top && prevBottom !== bottom) {
      handleScroll()
    }
  },
  componentWillUnmount() {
    const { handleScroll } = this.props
    window.removeEventListener('scroll', handleScroll)
  }
})

export default compose(
  withInfinityScrollRef,
  withScrollHandlers,
  withEventListenerManagement
)(InfinityScroll)

